import React from 'react';
import { BellOff, BellRing } from 'lucide-react';
import { useNotifications } from '../../contexts/NotificationContext';
import { useToast } from '../../contexts/ToastContext';

/**
 * Mute-all toggle rendered next to the NotificationBell. Muting suppresses
 * the in-app lead popups and notification sounds on THIS device only — the
 * bell keeps receiving notifications and counting unread as normal, so
 * nothing is missed, just quiet. The preference persists per user per
 * device (localStorage).
 */
export const NotificationMuteToggle: React.FC = () => {
  const { muted, toggleMuted } = useNotifications();
  const { showToast } = useToast();

  const handleToggle = () => {
    toggleMuted();
    if (muted) {
      showToast('info', 'Notifications unmuted', 'Lead popups and sounds are back on for this device.');
    } else {
      showToast('info', 'Notifications muted', 'No more popups or sounds on this device — the bell still collects everything.');
    }
  };

  return (
    <button
      onClick={handleToggle}
      title={muted ? 'Unmute notification popups & sounds' : 'Mute notification popups & sounds'}
      aria-pressed={muted}
      aria-label={muted ? 'Unmute notifications' : 'Mute notifications'}
      className={`relative p-2 rounded-full transition-colors ${
        muted
          ? 'text-amber-600 bg-amber-50 hover:bg-amber-100'
          : 'text-neutral-400 hover:text-neutral-600 hover:bg-neutral-100'
      }`}
    >
      {muted ? <BellOff className="w-5 h-5" /> : <BellRing className="w-5 h-5" />}
    </button>
  );
};
